import Model from 'scripts/poppet/model';
import { T } from 'defa-object';

/**
 * defa.models.Forecast
 * The DEFA Forecast model.
 * @version 1.3.0
 */

const paths = {
	icons: '/assets/vendor/yr/%s.svg',
};

const Forecast = Model.extend({
	
	defaults: {
		from: '',//"2019-03-27T12:00:00Z"
		to: '',//"2019-03-27T18:00:00Z"
		symbol: '',//"03d"
		temperature: null,//7
		windDirection: null,//142.7
		windSpeed: null,//1
		iconPath: '',
		backgroundPosition: '',
		dayName: '',
		time: '',
	},
	
	getDate: function(){
		return this.get('from').getDate();
	},
	
	setDayName: function() {
		this.set({dayName: T.shortDayName( this.get('from').getDay() )});
		this.set({time: this.get('from').toTimeString().slice(0,5)});
	},

	setIconPath: function() {  
		this.set({iconPath: paths.icons.replace('%s', this.get('symbol'))});
	},

	setBackgroundPositionForWind: function () {
		let speed = this.get('windSpeed');
		let direction = this.get('windDirection');

		let left_index = Math.floor(((direction+90)%360) / 10); // 10 degrees per frame. Add 90 degrees because spritemap is set to 0 degrees = east.

		let speed_groups = [
			0.0,
			0.3,
			1.6,
			3.4,
			5.5,
			8.0,
			10.8,
			13.9,
			17.2,
			20.8,
			24.5,
			28.5,
			32.6
		];

		let top_index =  -1; // 1 Group per row

		for (let i in speed_groups) {
			if (speed >= speed_groups[i]) {
				top_index++;
			}
		}

		let cell_size = 32;

		this.set({backgroundPosition: '-' + (left_index*cell_size) + 'px -' + (top_index*cell_size) + 'px'});
  },
	
});

export default Forecast;